import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { FC, useEffect, useMemo, useState } from "react";
import { Abordagem } from "src/apis/eezyfamily";
import NoDataAlert from "src/pages/components/NoDataAlert";

const ROWS = 10;

type Props = {
  abordagens: Abordagem[];
  onEdit: (item: Abordagem) => void;
  onDelete: (id: number) => void;
};

const AbordagensTable: FC<Props> = ({
  abordagens,
  onEdit,
  onDelete,
}): JSX.Element => {
  const hasData = useMemo(
    () => Boolean(abordagens) && abordagens.length > 0,
    [abordagens]
  );
  const [entries, setEntries] = useState<Abordagem[]>(abordagens);
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (hasData) setEntries(abordagens);
  }, [hasData, abordagens]);

  const pageSlice = entries.slice(page * ROWS, page * ROWS + ROWS);

  if (!hasData) return <NoDataAlert />;

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Typography fontWeight={600}>Abordagem</Typography></TableCell>
              <TableCell align="right"><Typography fontWeight={600}>Ações</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageSlice.map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>{item.approach}</TableCell>
                <TableCell align="right">
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar">
                      <IconButton size="small" onClick={() => onEdit(item)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton size="small" onClick={() => onDelete(item.id)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={entries.length}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={ROWS}
        rowsPerPageOptions={[ROWS]}
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </>
  );
};

export default AbordagensTable;
